import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import React, { useState } from "react";
import { globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import { PageLoader } from "../../../shared_elements";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";

const AddEditManufacturers = ({ params, toggleModalFn, addEditManufacturers, modeType, getResponseBack }) => {
    const [data, setData] = useState(addEditManufacturers?.data);
    const [error, setError] = useState({ modal: false, data: null });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }

    const isDataChanged = () => {
        const originalData = addEditManufacturers?.data || {};
        return (
            data?.name !== originalData?.name ||
            data?.address !== originalData?.address ||
            data?.remarks !== originalData?.remarks
        );
    };

    const onAddEditManufacturers = () => {
        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter Manufacturers Name',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);

            let payload = Object.assign({}, data);

            payload = {
                id: payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                address: payload?.address ? payload?.address : null,
                remarks: payload?.remarks ? payload?.remarks : null,
            }

            const apiUrl = data?.id ? `config-data/manufacturers/bulk-update/` : `config-data/manufacturers/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Manufacturers Updated Successfully' : 'Manufacturers Added Successfully',
                            page_title: 'Config Data : Manufacturers',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false)
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Manufacturers Updation Failed' : 'Manufacturers Added Failed',
                            page_title: 'Config Data : Manufacturers',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message,
                            data:JSON.stringify(payload)
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }
    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit ' : modeType === 'view' ? 'View' : 'Add '} Manufacturer
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required={modeType !== 'view'}
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='address'
                                    label='Address'
                                    disabled={modeType === 'view'}
                                    value={data?.address || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={2}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('address', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Manufacturers', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Manufacturers form` }) }} color='primary' size='small' variant='outlined'>{modeType === 'view' ? 'Close' : 'Cancel'}</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditManufacturers(); trackActivity('Console Management', { page_title: 'Config Data : Manufacturers', item_type: 'Save Button ', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Manufacturers form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item} />)}
        </>
    )
}

export default AddEditManufacturers